/* global Swiper */
// *******************************************************************************
// 1.0 - Testimonials slider
// *******************************************************************************

const testimonialsSliderElements = document.querySelectorAll('[data-slider="testimonials-slider"]');

const testimonialsSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 40,
  loop: true,
  speed: 600,
  autoHeight: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

testimonialsSliderElements.forEach((el) => {
  const testimonialsSliderParent = el.closest('.testimonials');
  const paginationElement = testimonialsSliderParent.querySelector('.swiper-pagination');
  const arrowRight = testimonialsSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = testimonialsSliderParent.querySelector('.swiper-button-prev');

  testimonialsSliderOptions.navigation.nextEl = arrowRight;
  testimonialsSliderOptions.navigation.prevEl = arrowLeft;
  testimonialsSliderOptions.pagination.el = paginationElement;

  // eslint-disable-next-line no-new
  new Swiper(el, testimonialsSliderOptions);
});
